import ShapeEllipseIcon from '@atlaskit/icon-lab/core/shape-ellipse';
import * as React from 'react';

export function SvgShapeEllipse() {
  return <ShapeEllipseIcon label="" testId="ads-refreshed-icon" />;
}
